import React from 'react';

const About: React.FC = () => {
  return (
    <div>
      <h1>About PortfoliosLab</h1>
      <p>This is the about page for PortfoliosLab. It will contain information about our company, mission, and services.</p>
    </div>
  );
};

export default About;
